import angular from 'angular';
import components from './components';
import loanCompactDetails from './loanCompactDetails';
import './style.scss';

export default angular
  .module('contactLending.components.loanCompactDetails', [components])
  .component('loanCompactDetails', loanCompactDetails).name;
